document.addEventListener('DOMContentLoaded', () => {
  const allAnimated = document.querySelectorAll('[data-scroll-animation]');
  if (!allAnimated.length) return;

  const topLevelAnimated = Array.from(allAnimated).filter(
    (element) => !element.parentElement?.closest('[data-scroll-animation]')
  );

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animation-visible');
        entry.target.querySelectorAll('[data-scroll-animation]').forEach((nested) => {
          nested.classList.add('animation-visible');
        });
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });

  topLevelAnimated.forEach((block) => observer.observe(block));
});
